/**
 * Navigation utilities for cross-project linking
 */

export interface NavigationParams {
  project?: string;
  topic?: string;
  category?: string;
  skill?: string;
  scenario?: string;
  [key: string]: string | undefined;
}

/**
 * Navigate to Talk to Tally with optional parameters
 */
export const navigateToTally = (params: {
  topic?: string;
  category?: string;
  skill?: string;
  scenario?: string;
  context?: string; // JSON stringified additional context
  autoStart?: boolean;
}) => {
  const urlParams = new URLSearchParams({
    project: 'talk-to-tally-v2',
    ...Object.fromEntries(
      Object.entries(params).filter(([_, value]) => value !== undefined)
    ),
  });
  
  window.location.search = urlParams.toString();
};

/**
 * Navigate to Skills Manager with optional parameters
 */
export const navigateToSkills = (params: {
  category?: string;
  skill?: string;
  subskill?: string;
}) => {
  const urlParams = new URLSearchParams({
    project: 'skills-manager',
    ...Object.fromEntries(
      Object.entries(params).filter(([_, value]) => value !== undefined)
    ),
  });
  
  window.location.search = urlParams.toString();
};

/**
 * Parse current URL parameters
 */
export const parseUrlParams = (): NavigationParams => {
  const params = new URLSearchParams(window.location.search);
  const result: NavigationParams = {};
  
  params.forEach((value, key) => {
    result[key] = value;
  });
  
  return result;
};

/**
 * Clear URL parameters (useful for resetting state)
 */
export const clearUrlParams = () => {
  window.history.replaceState({}, '', window.location.pathname);
};

/**
 * Update URL parameters without reload
 */
export const updateUrlParams = (params: NavigationParams) => {
  const filteredParams: Record<string, string> = {};
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined) {
      filteredParams[key] = value;
    }
  });
  
  const urlParams = new URLSearchParams(filteredParams);
  const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
  window.history.replaceState({}, '', newUrl);
};